const BROKERBAY_ADMIN_REGEX = /admin\+[ -~]+@brokerbay\.(ca|com)/;

export const isBrokerBayAdminEmail = (targetUserEmail: string) =>
  Boolean(targetUserEmail.match(BROKERBAY_ADMIN_REGEX));
